export * from './scorm-wrapper.service';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/scorm-wrapper/index.ts